import styled from 'styled-components';

import {
    ExclSign,
    ApplSign,
} from 'ui/toyota/outlines';

export default {
    InfoBlockBox: styled.div.attrs({ className: 'info-block-box' })`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin: 5px 5px 8px;
        @media (min-width: 700px) {
            margin-bottom: 29px;
        }
    `,
    InfoBlockLabel: styled.span.attrs({ className: 'info-block-label' })`
        font-family: Toyota Display,serif;
        font-size: 16px;
        line-height: 25px;
        color: #595D60;
        opacity: 0.4;
        margin-bottom: 14px;
        white-space: nowrap;
        @media (min-width: 700px) {
            margin-bottom: 6px;
        }
    `,
    InfoBlockStatus: styled.span.attrs({ className: 'info-block-status' })`
        width: 20px;
        height: 20px;
        background-image: url(${props => props.status && (props.status !== 'Ожидает оплаты' && props.status !== 'Захолдирован' && props.status !== 'Отменен') ? ApplSign : ExclSign});
        background-position: center;
        background-size: cover;
        margin-right: 9px;
        margin-bottom: 2px;
        &:hover::after {
            content: '${props => props.dataTitle}';
            width: 250px;
            white-space: normal;
            position: relative;
            top: 25px;
            left: 20px;
            background: #ffffff;
            border-radius: 0;
            color: #455a64;
            box-shadow: 0 2px 8px 0 rgba(33, 43, 47, 0.52);
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 1.42857143;
            font-family: Toyota Display,serif;
            padding: 6px 8px;
            display: block;
            z-index: 1000;
            @media (min-width: 700px) {
                width: 100%;
                white-space: nowrap;
                display: table;
            }
        }
    `,
    InfoBlockText: styled.span.attrs({ className: 'info-block-text' })`
        font-family: Toyota Display Bold,serif;
        font-size: 16px;
        line-height: 25px;
        color: ${props => !props.status || (props.status === 'Ожидает оплаты' || props.status === 'Захолдирован') ? '#000000' : props.status === 'Отменен' ? '#E50000' : '#4CAF50'};
        display: flex;
        align-items: center;
        white-space: normal;
        text-align: left;
        @media (min-width: 700px) {
            font-size: 18px;
        }
    `,
};
